import type {ReactElement} from 'react';
import React from 'react';
import {BaseVolumeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-volume-option/base-volume-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromVideoSlideItem} from '@Hooks/poster-editor/useGetKeyFromVideoSlideItem';

export function VideoSlideItemVolumeOption(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const volume = useGetKeyFromVideoSlideItem('volume');

  if (!activeItem || !activeSlide || !activeSlideUID) {
    return null;
  }

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide?.isVideoSlide()) {
    return null;
  }

  if (volume === undefined) {
    return null;
  }

  const updateAudioItemVolume = (val: number, undoable: boolean): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        volume: val,
      },
      {undoable}
    );
  };

  const onMuteUnmute = (): void => {
    void activeItem.updateSlideFromObject(activeSlide.uid, {
      volume: activeSlide.isMuted() ? 1 : 0,
    });
  };

  return <BaseVolumeOption onMuteUnmute={onMuteUnmute} volume={volume} onUpdateVolume={updateAudioItemVolume} />;
}
